export const MIN_RATE_REVIEWS_FOR_DISPLAY = 3;
